/* =================================================
	=  Constant variable + Helper Function  =
	=========================================

	- Develeopment Env.
		see in :		.env.development
		apiMKPUrl =	'http://localhost:47756'

	- Production Env.
		see in :		.env.production
		apiMKPUrl =	'https://marketpett.repttown.com/n'

==================================================== */

// const apiMKPUrl = 'http://localhost:5000'
// const apiMKPUrl = 'http://192.168.1.30:47756'
const baseMKPUrl = process.env.VUE_APP_API_URL;
export const apiMKPUrl = `${baseMKPUrl}/api/v1`;

const baseRPTUrl = process.env.VUE_APP_REPTTOWN_API_URL;
export const apiRPTUrl = `${baseRPTUrl}/api/v1`;
export const appRPTUrl = process.env.VUE_APP_REPTTOWN_URL;

export const server = {
	TOKEN_EXPIRE: `tokenexpire`,
	ACCESS_TOKEN: `accesstoken`,
	REFRESH_TOKEN: `refreshtoken`,
	CART_ITEM: `items`,
	USER_INFO: `userinfo`,
	STORE_INFO: `storeinfo`,
	ROUTES_CACHE: `route`,
	USER_CONFIG: `userconfig`,
	VIEW_PRODUCT_CACHE: `markprod`,

	// ReptTown
	RPT_ROUTES_CACHE: `rptroute`,
};

export const other = {
	ROUTE_URL: `route`,
	PRODUCT_URL: `product`,
	GET_PRODUCT_BY_STORE_URL: `product/store`,
	GET_STORE_URL: `store`,
	CLICK_CONTACT_STORE_URL: `contactstore`,
};

export const authen = {
	LOGIN_URL: `authen/login`,
	REGISTER_URL: `authen/register`,
	RESETPASSWORD_URL: `authen/resetpwd`,
	RENEWTOKEN_URL: `authen/renewtoken`,
	LOGOUT_URL: `authen/logout`,
};

export const user = {
	PROFILE_URL: `user/profile`,
	REPORT_PRODUCT_URL: `user/report/product`,
	REPORT_STORE_URL: `user/report/store`,
	FOLLOW_STORE_URL: `user/follow/store`,
};

export const store = {
	CREATE_STORE_URL: `store/create`,
	STORE_INFO_URL: `store/info`,
	STORE_PRODUCT_URL: `store/product`,
}

export const admin = {
	STORE_MANAGER_URL: `imadmin/store`,
	PRODUCT_MANAGER_URL: `imadmin/store/product`,

	USER_LIST_URL: `imadmin/user`,
	USER_ROLE_URL: `imadmin/user/role`,
	USER_BAN_URL: `imadmin/user/ban`,

	REPORTED_STORE_URL: `imadmin/report/store`,
	REPORTED_PRODUCT_URL: `imadmin/report/product`,
	REPORTED_USER_URL: `imadmin/report/user`,
	FEEDBACK_URL: `imadmin/feedback`,
	COLLECTION_DOC_URL: `imadmin/doc`,

	VIEWSTAT_URL: `imadmin/stat/view`,
	VIEWSTAT_RAW_URL: `imadmin/stat/view/raw`,
	LOGS_URL: `imadmin/logs`,
	ROUTE_URL: `imadmin/route`,
};

export const repttown = {
	ROUTE_URL: `route`,
}

export const userConfig = {
	KEEP_SIGNIN: `ksignin`,
}

const ImageSize = {
	// Default
	maxSizeMB: 0.5,
	maxWidthOrHeight: 4000,

	// x10, x3, x1
	HIGH: { maxSizeMB: 0.5, maxWidthOrHeight: 4000 },
	MID: { maxSizeMB: 0.15, maxWidthOrHeight: 1600 },
	LOW: { maxSizeMB: 0.05, maxWidthOrHeight: 800 },
}

// ===============================================================
// =                      Helper Function                        =
// ===============================================================

if (process.env.NODE_ENV != "production")
	console.log(`API : ${process.env.VUE_APP_API_URL}`);
import imageCompression from 'browser-image-compression';

/**
 * Return Product imageUrl from imageName
 * @param {String} imageName 
 * @returns 
 */
export const productImageUrl = (imageName) => {
	// return `https://dev.marketpett.com/n/images/product/${imageName}`
	return `${baseMKPUrl}/images/product/${imageName}`
};

/**
 * Return Product thumbnailUrl from imageName
 * @param {String} imageName 
 * @returns 
 */
 export const productThumbnailUrl = (imageName) => {
	// return `https://dev.marketpett.com/n/images/product/thumb/${imageName}`
	return `${baseMKPUrl}/images/product/thumb/${imageName}.jpeg`
};

/**
 * Return Store imageUrl from imageName
 * @param {String} imageName 
 * @returns 
 */
export const storeImageUrl = (imageName) => {
	if (!imageName) return null;
	return `${baseMKPUrl}/images/store/${imageName}`
};

/**
 * Return User imageUrl from imageName
 * @param {String} imageName 
 * @returns 
 */
export const userImageUrl = (imageName) => {
	return `${baseMKPUrl}/images/user/${imageName}`
};

/**
 * Return User credential imageUrl from imageName
 * @param {String} imageName 
 * @returns 
 */
 export const credentialImageUrl = (imageName) => {
	return `${baseMKPUrl}/images/credential/${imageName}`
};

/**
 * Add first image (and parse to URL) to key: image and remove key: images, Translate discountPrice
 * @param {[{_id: String, title: String, price: Number, images: Array}]} products 
 * @returns {[{_id?: String, title?: String, price?: Number, image?: String}]}
 */
// export const parseProductsList = (products) => {
// 	if (!products) return;
// 	products.forEach((product) => {
// 		// NOTE! PRICE PARSING MOVE TO api.js - Parse Price 'WHEN GET RESULT' (@api.js)
// 		product.image = productImageUrl(product.images[0]);
// 	});
// 	return products;
// }

/**
 * Helper stupid loop
 * @param {[{path: String, title: String}]} arr 
 * @param {String} path 
 * @returns {{path: String, title: String, s2?: Array}}
 */
const _getSub = (subTypes, path) => {
	for (let subType of subTypes) {
		if (subType.path == path) return subType.title;
		if (subType.subTypes) {
			let res = _getSub(subType.subTypes, path);
			if (res) return res;
		}
	}
	return null;
}

/**
 * Get the title from path, (faster with subTypes)
 * @param {String} type 
 * @param {String} path
 * @param {Array?} subTypes
 * @returns {String}
 */
export const getTitle = async (type, path, subTypes=null) => {
	if (!type || !path) return null;
	const api = require("./api").default;
	let route = await api.getRoute();
	return _getSub(subTypes || route[type], path);
};

/**
 * Find Menues Just First Level
 * @param {*} subTypes 
 * @param {*} _path 
 * @returns 
 */
export const findMenusFirstLevel = (subTypes, _path) => {
    let res = subTypes.find(({ path }) => path == _path);
    if (!res) return [];
    return res;
}

function _findMenus(subTypes, { p1, p2, p3, p4 }) {
	if (p4) {
        let parent = _findMenus(subTypes, { p1, p2, p3 });
        let res = findMenusFirstLevel(parent, p4);
        return res.subTypes || [];
    } else if (p3) {
        let parent = _findMenus(subTypes, { p1, p2 });
        let res = findMenusFirstLevel(parent, p3);
        return res.subTypes || [];
    } else if (p2) {
        let parent = _findMenus(subTypes, { p1 });
        let res = findMenusFirstLevel(parent, p2);
        return res.subTypes || [];
    } else if (p1) {
        let res = findMenusFirstLevel(subTypes, p1);
		return res.subTypes || [];
    }
    return [];
}

/**
 * Find sub menu from path
 * @param {Object} info
 * @returns {Array}
 */
export const getMenus = async (info) => {
	const api = require("./api").default;
    let route = await api.getRoute();
	for (let key in info) if (info[key] != undefined && typeof(info[key]) != 'string') return [];
	const { type, p1, p2, p3, p4 } = info;
	if (!p1) return route[type] || [];
    return _findMenus(route[type], { p1, p2, p3, p4 })
}

/**
 * 
 * @param {File|Event} obj 
 * @param {{quality: String, onProgress: Function}} options
 * @returns {Array}
 */
export const compressImages = async (obj, { quality, onProgress } = {}) => {
	if (!obj) return [];
	let files = [...obj];
	let FilesSize = { original: 0, compress: 0 };
	let result = [];
	function _onProgress(p) {
		// console.log(`Compress: ${p}%`);
		if (!onProgress) return;
		onProgress( ((result.length * 100 + p)/files.length).toFixed(2) );
	}
	var options = {
		maxSizeMB: ImageSize.maxSizeMB,
		maxWidthOrHeight: ImageSize.maxWidthOrHeight,
		useWebWorker: true,
		onProgress: _onProgress
	}
	if (ImageSize[quality]) {
		options.maxSizeMB = ImageSize[quality].maxSizeMB;
		options.maxWidthOrHeight = ImageSize[quality].maxWidthOrHeight;
	}
	for (let i in files) {
		let file = files[i];
		let compressedFile = await imageCompression(file, options);
		FilesSize.original += file.size;
		FilesSize.compress += compressedFile.size;
		result.push(new File([compressedFile], compressedFile.name));
	}
	if (process.env.NODE_ENV != "production")
		console.log( "Compress:" , FilesSize.original/(10**6), "to", FilesSize.compress/(10**6), "MB" );
	return result;
}

// ==============================================================
// =                      Setup Function                        =
// ==============================================================

var oneLayerProductType = [];
export const genSearchProductType = (route) => {
	if (!route) return;
	// console.time('ge');
	function generate(path, types, level=1) {
		for (let i = 0; i < types.length; i++) {
			let type = { ...types[i] };
			if (type.subTypes && level < 3) {
				generate(`${path}/${type.path}`, type.subTypes, level + 1);
				delete type.subTypes;
			}
			oneLayerProductType.push({ ...type, path: `/${path}/${type.path}`, level });
		}
	}
	for (let key in route)
		generate(key, route[key]);
	// console.timeEnd('ge');
}

var previousKey = null;
export const searchProductType = (key) => {
	if (!oneLayerProductType.length) return [];
	if (!key) return oneLayerProductType.filter(type => type.level == 1);
	if (key.includes(previousKey)) return [];
	let regEx = RegExp(`^${key.toLowerCase()}.*`);
	let pathRegEx = RegExp(`.*${key.toLowerCase().replace(/\s+/g, '.*')}.*`);
	let result = oneLayerProductType.filter(type => regEx.test(type.title.toLowerCase()));
	result = result.concat(...oneLayerProductType.filter(type => type.titleTh && pathRegEx.test(type.titleTh)));
	result = result.concat(...oneLayerProductType.filter(type => pathRegEx.test(type.path)));
	if (!result.length) {
		if (!previousKey) previousKey = key;
	} else previousKey = null;
	return result;
}